import { OrganizationReportInstallationEntity } from '../entities/';
import { authResource } from './Auth';
import { schema } from '@data-client/rest';
export const OrganizationReportInstallationResource = authResource({
    path: '/organizations/:organizationId/reports/installations/:installationId?',
    searchParams: {},
    schema: OrganizationReportInstallationEntity
}).extend('getList', {
    schema: {
        counts: new schema.Collection([OrganizationReportInstallationEntity]),
        items: new schema.Collection([OrganizationReportInstallationEntity])
    }
});
